import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TeamSection: React.FC = () => {
  const { language } = useLanguage();
  
  // Multilingual content
  const getTitle = () => {
    switch (language) {
      case 'de': return 'Unser Team - Ihre Spezialisten für Zahngesundheit';
      case 'en': return 'Our Team - Your Dental Health Specialists';
      case 'es': return 'Nuestro Equipo - Sus Especialistas en Salud Dental';
      case 'ru': return 'Наша команда - ваши специалисты по здоровью зубов';
      default: return 'Unser Team - Ihre Spezialisten für Zahngesundheit';
    }
  };
  
  const getDescription = () => {
    switch (language) {
      case 'de': 
        return 'Bei SeaDent Mallorca erwartet Sie ein erfahrenes Team aus qualifizierten Zahnärzten und freundlichem Fachpersonal. Wir kombinieren Expertise mit Einfühlungsvermögen, um Ihnen die bestmögliche Behandlung in angenehmer Atmosphäre zu bieten.';
      case 'en': 
        return 'At SeaDent Mallorca, an experienced team of qualified dentists and friendly professionals awaits you. We combine expertise with empathy to provide you with the best possible treatment in a pleasant atmosphere.';
      case 'es': 
        return 'En SeaDent Mallorca, le espera un equipo experimentado de dentistas cualificados y profesionales amables. Combinamos experiencia con empatía para brindarle el mejor tratamiento posible en un ambiente agradable.';
      case 'ru': 
        return 'В SeaDent Майорка вас ждет опытная команда квалифицированных стоматологов и дружелюбных специалистов. Мы сочетаем профессионализм с чутким отношением, чтобы обеспечить вам наилучшее возможное лечение в приятной атмосфере.';
      default: 
        return 'Bei SeaDent Mallorca erwartet Sie ein erfahrenes Team aus qualifizierten Zahnärzten und freundlichem Fachpersonal. Wir kombinieren Expertise mit Einfühlungsvermögen, um Ihnen die bestmögliche Behandlung in angenehmer Atmosphäre zu bieten.';
    }
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold text-navy mb-4">{getTitle()}</h2>
          <p className="text-gray-700 text-lg">{getDescription()}</p>
        </div>
        
        <div className="relative">
          <div className="rounded-lg overflow-hidden shadow-xl mx-auto max-w-4xl">
            <img 
              src="/images/SeaDent Team.jpg" 
              alt="SeaDent Mallorca Team" 
              className="w-full h-auto"
            />
          </div>
          <div className="bg-white py-4 px-6 rounded-b-lg shadow-lg max-w-4xl mx-auto">
            <p className="text-center text-gray-700 font-medium">
              {language === 'de' 
                ? 'Ihr SeaDent Mallorca Team freut sich auf Ihren Besuch!' 
                : (language === 'en' 
                  ? 'Your SeaDent Mallorca team looks forward to your visit!' 
                  : (language === 'ru'
                    ? 'Команда SeaDent Майорка ждет вашего визита!'
                    : '¡Su equipo de SeaDent Mallorca espera su visita!'))}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection; 